import { domain } from "../helpers/route_helper";

export const getProducts = (state, user_id, source, partner_id) => {
  return window.$.ajax({
    method: "GET",
    url: `${domain}/api/product_offering`,
    data: { user_id, state, source, partner_id }
  });
};
